export default __webpack_public_path__ + "static/media/Multiple-Screens.c4e90dab.png";